import Phaser from 'phaser';

import { BOUNCY_SUMS_SCENE_HEIGHT, BOUNCY_SUMS_SCENE_WIDTH } from './scenes/BouncySumsScene';
import { BOUNCY_SUMS_SCENES } from './scenes/sceneRegistry';
import { getDevicePixelRatio } from './utils/canvasSize';

function shouldUseCanvasRenderer(): boolean {
	if (typeof navigator === 'undefined') {
		return false;
	}

	const isIpadWithDesktopUserAgent = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

	return /Android|iPad|iPhone|iPod/i.test(navigator.userAgent) || isIpadWithDesktopUserAgent;
}

export function createGameConfig(parent: HTMLElement): Phaser.Types.Core.GameConfig {
	const devicePixelRatio = getDevicePixelRatio();

	return {
		type: shouldUseCanvasRenderer() ? Phaser.CANVAS : Phaser.AUTO,
		parent,
		width: Math.max(1, Math.round((parent.clientWidth || BOUNCY_SUMS_SCENE_WIDTH) * devicePixelRatio)),
		height: Math.max(1, Math.round((parent.clientHeight || BOUNCY_SUMS_SCENE_HEIGHT) * devicePixelRatio)),
		transparent: true,
		scene: BOUNCY_SUMS_SCENES,
		scale: {
			mode: Phaser.Scale.NONE,
		},
		audio: {
			disableWebAudio: false,
		},
		antialias: true,
		roundPixels: true,
	};
}
